// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(orderStage) {
  if (orderStage === undefined) {
    return ;
  }
  switch (orderStage) {
    case "Accept Start Transit" :
        return /* AcceptStartTransit */1;
    case "Accept Trip Vicinity" :
        return /* AcceptTripVicinity */0;
    case "End Trip To End Job" :
        return /* EndTripEndJob */5;
    case "End Trip Vicinity" :
        return /* EndTripVicinity */4;
    case "Non Order Related" :
        return /* Nor */7;
    case "Post End Job" :
        return /* PostEndJob */6;
    case "Start End Transit" :
        return /* StartEndTransit */3;
    case "Start Trip Vicinity" :
        return /* StartTripVicinity */2;
    default:
      return ;
  }
}

function nonOptionalfromString(orderStage) {
  switch (orderStage) {
    case "Accept Start Transit" :
        return /* AcceptStartTransit */1;
    case "Accept Trip Vicinity" :
        return /* AcceptTripVicinity */0;
    case "End Trip To End Job" :
        return /* EndTripEndJob */5;
    case "End Trip Vicinity" :
        return /* EndTripVicinity */4;
    case "Non Order Related" :
        return /* Nor */7;
    case "Post End Job" :
        return /* PostEndJob */6;
    case "Start End Transit" :
        return /* StartEndTransit */3;
    case "Start Trip Vicinity" :
        return /* StartTripVicinity */2;
    default:
      return ErrorUtils$Catalyst.raiseError("OrderStage.re", "Invalid order stage", orderStage);
  }
}

function toString(orderStage) {
  switch (orderStage) {
    case /* AcceptTripVicinity */0 :
        return "Accept Trip Vicinity";
    case /* AcceptStartTransit */1 :
        return "Accept Start Transit";
    case /* StartTripVicinity */2 :
        return "Start Trip Vicinity";
    case /* StartEndTransit */3 :
        return "Start End Transit";
    case /* EndTripVicinity */4 :
        return "End Trip Vicinity";
    case /* EndTripEndJob */5 :
        return "End Trip To End Job";
    case /* PostEndJob */6 :
        return "Post End Job";
    case /* Nor */7 :
        return "Non Order Related";
    
  }
}

function getListOfOrderStage(param) {
  return {
          hd: /* AcceptTripVicinity */0,
          tl: {
            hd: /* AcceptStartTransit */1,
            tl: {
              hd: /* StartTripVicinity */2,
              tl: {
                hd: /* StartEndTransit */3,
                tl: {
                  hd: /* EndTripVicinity */4,
                  tl: {
                    hd: /* EndTripEndJob */5,
                    tl: {
                      hd: /* PostEndJob */6,
                      tl: {
                        hd: /* Nor */7,
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), nonOptionalfromString);
}

export {
  fromString ,
  nonOptionalfromString ,
  toString ,
  getListOfOrderStage ,
  t_decode ,
  
}
/* No side effect */
